import { useRef } from "react"
import "./css/SignatureInput.css"
import SignatureCanvas from 'react-signature-canvas'
import { toast } from "react-toastify"

const SignatureInput = ({ setPopup, setSignature }) => {
    const signatureref = useRef()

    const handleSave = () => {
        if (signatureref.current.isEmpty()) {
            toast.info("Signature is required")
            return
        }

        const dataURL = signatureref.current.toDataURL()
        setSignature(dataURL)

        setPopup(false)
    }

    return (
        <div className="_3nce" onClick={() => setPopup(false)}>
            <div className="class-lard" onClick={e => e.stopPropagation()}>
                <div>
                    <div className="missteps-ones">Authorization for creating invoice</div>
                    <div>Please sign the canvas</div>
                </div>
                <div className="bellmen-sox">
                    <SignatureCanvas
                        ref={signatureref}
                        penColor="rgb(41, 41, 41)"
                        canvasProps={{ width: 500, height: 200, className: "curvedly-brie" }}
                    />
                </div>
                <div className="enrheum-cub">
                    <div className="danker-cod">
                        <button onClick={() => handleSave()}>Proceed</button>
                        <button onClick={() => signatureref.current.clear()}>Clear</button>
                    </div>
                    <div className="sizer-punt">
                        <button onClick={() => setPopup(false)}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SignatureInput
